<div class="overlay-spinner">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>
